import { Expose } from '../serialization/class-transformer/decorators';
import { BaseIdentity } from './base-identity';
import { BaseRootModel } from './base-root-model';
import { OCCModelInterface } from './occ-model.interface';


export class OCCModel<TIdentity extends BaseIdentity> extends BaseRootModel<TIdentity> implements OCCModelInterface {

    @Expose()
    occ: string;

    @Expose()
    reservedData: string;

    // @Expose()
    // oCCV: string;

    // @Expose()
    // oCCVN: number;

}
